export default __webpack_public_path__ + "static/media/reanime-circle-name-image-transparent-compressed.5a57afec.png";